export function diffFromOrigin<T extends { id: any }>(
    originMap: Map<T['id'], T>,
    current: T[],
    equals: (a: T, b: T) => boolean
) {
    const created: T[] = []
    const edited: T[] = []
    const deletedIds: T['id'][] = []

    const currentMap = new Map<T['id'], T>()
    for (const r of current) currentMap.set(r.id, r)

    // created + edited
    for (const r of current) {
        const old = originMap.get(r.id)

        const isNew = !r.id || (typeof r.id === 'number' && r.id <= 0) || (typeof r.id === 'string' && r.id.startsWith('new-'))

        if (!old) {
            created.push(isNew ? { ...r, id: 0 as unknown as T['id'] } : r)
        } else if (isNew) {
            // ALWAYS save generated/new rows if they are present, even if unmodified from their generated state
            created.push({ ...r, id: 0 as unknown as T['id'] })
        } else if (!equals(r, old)) {
            edited.push(r)
        }
    }

    // deleted
    for (const id of originMap.keys()) {
        const isNew = !id || (typeof id === 'number' && id <= 0) || (typeof id === 'string' && id.startsWith('new-'))

        if (!currentMap.has(id) && !isNew) deletedIds.push(id)
    }

    return {
        created,
        edited,
        deletedIds,
        hasChanges: created.length > 0 || edited.length > 0 || deletedIds.length > 0,
    }
}
